import React from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { DialogEnums } from "models/enums";
import { SelectionDialogProps } from "models/propTypes/selectionPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import AsyncResultListTabContent from "../lists/asyncResultList/asyncResultListTabContent";
import TabContentDialog from "../dialogs/_tabContentDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelectionDialog: React.FC<SelectionDialogProps> = (props) => {
  const onChange = (item: SelectionItem) => {
    props.onChange(item);
    props.cancelHandler();
  };

  const children = React.useMemo(
    () => AsyncResultListTabContent(0, onChange, async () => props.items, props.searchFunc),
    [props.items]
  );

  return (
    <TabContentDialog
      isOpen={props.isOpen}
      title={LocalizationHelperInstance.getFormattedMessage(props.selectionDialogTitle)}
      titleIcon={IconDefinitionConstants.WList}
      dialogType={DialogEnums.DialogType.TabContent}
      subTitle={
        props.selectionDialogSubTitle
          ? LocalizationHelperInstance.getFormattedMessage(props.selectionDialogSubTitle)
          : ""
      }
      maxWidth="sm"
      children={children}
      onClose={props.cancelHandler}
    />
  );
};

export default SelectionDialog;
